import { Integer } from "@type-r/ext-types";
import { AttributesMixin, define, Model, type } from "@type-r/models";
import { RelationshipModel } from "api";
import { fetchResponse, fetchJson, restfulIO } from "api/endpoint";
import { InvoiceModel } from "api/invoice";
import { globalStore } from 'api'
import { RecsInvoice } from "../../inmatch/api";

const root = '/api/v2/invoice-management/statement-of-customer';
const inmatchRoot = '/api/v2/recs/';
@define
export class DebthSummary extends Model {
    static endpoint = restfulIO(root);

    static attributes = {
        id: String, // relationship id
        amount: Number,
        count: Integer,
        overdueAmount: Number,
        overdueCount: Integer,
        due2weeks: Number,
        due2weeksCount: Integer,
        due2plusWeeks: Number,
        due2plusWeeksCount: Integer,
        disputed: Number,
        disputedCount: Integer,
        invoices: [InvoiceModel],
        recsInvoices: type([RecsInvoice]).dontSave.endpoint(restfulIO(inmatchRoot + 'invoice/filtered')),
    }

    get relationship(): RelationshipModel {
        return globalStore.relationships.get(this.id);
    }

    get customer() {
        return this.relationship.customer;
    }

    get customerName() {
        return this.customer.name;
    }

    get supplier() {
        return this.relationship.supplier;
    }

    async sendEmail(){
        const url = `${root}/${this.id}/send-statement-email`;
        await fetchResponse('POST', url);
    }

    async getLatestReportSent(){
        const url = `/api/communication/${this.relationship.id}/latest-statement-sent`;
        return await fetchJson('GET', url);
    }

    async export() {
        const url = `${root}/${this.id}/export`;
        var result = await fetchResponse('POST', url);
        const imageBlog = await result.blob();
        const imageURL = URL.createObjectURL(imageBlog);

        const anchor = document.createElement("a");
        anchor.href = imageURL;
        var filename = result.headers.get('content-disposition').match(/(?<=filename\=).*(?=;)/g);
        anchor.download = (filename as any) || "soc_report_export.xlsx";

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }
}
export interface DebthSummary extends AttributesMixin<typeof DebthSummary> { }